export enum AuthState {
  NOT_SET,
  AUTHORIZED,
}
